import React from "react"
import '../styles/aboutsection.css';
import AboutImg from '../img/aboutimg.jpg'
import { useInView } from '../hooks/useInView'

const AboutSection = () => {
    const { ref: portraitRef, inView: portraitInView } = useInView();
    const { ref: descriptionRef, inView: descriptionInView } = useInView();

    return(
        <React.Fragment>
            <div id="about">
                <div className="navbar-spacer"><p></p></div>
                <img src={AboutImg}
                     alt="..."
                     className={`about-portrait fade-in-up ${portraitInView ? 'animation-active' : ''}`}
                     ref={portraitRef}
                />
                <div
                    className={`about-description-box fade-in-up ${descriptionInView ? 'animation-active' : ''}`}
                    ref={descriptionRef}>
                    <p className="about-description">
                    Hi! I'm Daryl Dang, a passionate Software Engineer with a Bachelor's degree in
                    Software Engineering from the University of Calgary. I currently work at
                    Hexagon | NovAtel in the Aerospace & Defense department, where I contribute to
                    software development, testing, and automation across a range of products.
                    My interests include software quality and testing, system architecture and
                    design, web development, and other technical projects that spark my curiosity.
                    Outside of work, I enjoy tutoring and mentoring youth in programming, robotics,
                    and engineering fundamentals.
                    Feel free to reach out if you'd like to connect!
                    </p>
                </div>
                <div className="section-spacer"></div>
            </div>
        </React.Fragment>
    );
}

export default AboutSection;